import { useList } from '@refinedev/core';

import { Loading } from '@rrexpress/core';

import { BaseForm } from '@/components/form/form';
import FormField from '@/components/form/form-field';
import { useModal } from '@/hooks/useModal';
import { type IBranch } from '@/modules/branch/model/branch';

type UserManagementFormProps = {
  onFinish: (value: any) => void,
  type: 'create' | 'update',
  initialValue?: any,
  loading: boolean
};

const UserManagementForm = ({
  initialValue,
  onFinish,
  type,
  loading,
}: UserManagementFormProps) => {
  const { close } = useModal();
  const { data: responseRoles, isLoading } = useList({
    resource: 'cp-roles',
    dataProviderName: 'auth',
    pagination: { pageSize: 1000 },
  });
  const { data: responseBranches, isLoading: isBranchLoading } = useList({
    resource: 'branches',
    pagination: { pageSize: 1000 },
  });

  const roleOptions = ((responseRoles?.data || []) as IRole[])
    .filter((role) => role.role_name !== 'owner')?.map((role) => ({
      label: role.role_name,
      value: role.role_id,
    }));

  const branchOptions = ((responseBranches?.data || []) as IBranch[])
    .map((branch) => ({
      label: branch.branch_name,
      value: branch.branch_id,
    }));

  return (
    <div className="p-4">
      {(loading || isLoading || isBranchLoading) && (
        <Loading
          variant="circular"
          size={40}
          speed={0.6}
          indicatorCap="round"
        />
      )}
      {loading || isLoading || isBranchLoading
        ? ''
        : <BaseForm
          initialValue={type === 'update' ? initialValue : {}}
          onCancel={close}
          onFinish={onFinish}
        >
          <div className="mb-4 flex gap-3 items-center justify-between">
            <div className="w-[400px]">
              <FormField
                label="Nama Depan"
                component="form"
                name="first_name"
                componentProps={{
                  label: 'Nama Depan',
                  required: true,
                }}
              />
            </div>
          </div>
          <div className="mb-4 flex gap-3 items-center justify-between">
            <div className="w-[400px]">
              <FormField
                component="form"
                name="last_name"
                label="Nama Belakang"
                componentProps={{
                  label: 'Nama Belakang',
                  required: true,
                }}
              />
            </div>
          </div>
          <div className="mb-4 flex gap-3 items-center justify-between">
            <div className="w-[400px]">
              <FormField
                component="form"
                name="email"
                label="Email"
                componentProps={{
                  label: 'Email',
                  required: true,
                }}
              />
            </div>
          </div>
          <div className="mb-4 flex gap-3 items-center justify-between">
            <div className="w-[400px]">
              <FormField
                component="form" name="phone_number"
                label="No. Telp"
                componentProps={{
                  label: 'No. Telp',
                  required: true,
                }}
              />
            </div>
          </div>
          <div className="mb-4 flex gap-3 items-center justify-between">
            <div className="w-[400px]">
              <FormField
                component="dropdown"
                name="role_id"
                label="Roles"
                componentProps={{
                  label: 'Roles',
                  required: true,
                  id: 'roles',
                  options: roleOptions,
                  onSelectedOutputKey: 'value',
                }}
              />
            </div>
          </div>
          <div className="mb-4 flex gap-3 items-center justify-between">
            <div className="w-[400px]">
              <FormField
                component="dropdown"
                name="branch_id"
                label="Cabang"
                componentProps={{
                  label: 'Cabang',
                  options: branchOptions,
                  id: 'branch',
                  onSelectedOutputKey: 'value',
                }}
              />
            </div>
          </div>
          {type === 'update' && initialValue?.status !== 'active' && (
            <div className="mb-4 flex gap-3 items-center justify-between">
              <div className="w-[400px]">
                <FormField
                  component="checkbox"
                  name="is_send_confirmation_link"
                  componentProps={{
                    label: 'Kirim ulang link aktivasi',
                  }}
                />
              </div>
            </div>
          )}
        </BaseForm>
      }
    </div>
  );
};

export default UserManagementForm;
